// extracted by mini-css-extract-plugin
export default {"rounded":"iconCustom_rounded__vNzK7","rounded_dash":"iconCustom_rounded_dash__YDJJy","gen":"iconCustom_gen__8F91W","list":"iconCustom_list__ZhFX0","plus":"iconCustom_plus__lrMHu"};